module.exports = __webpack_public_path__ + "img/qrCode-fujingli.f9c69a66.jpg";